import { render, staticRenderFns } from "./ResourceSort.vue?vue&type=template&id=dc4f9c2a"
import script from "./ResourceSort.vue?vue&type=script&lang=js"
export * from "./ResourceSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports